<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">E-mails cadastrados nesta lista (exceto excluídos)</h3>

      <div class="card-tools">
        <form @submit.prevent>
          <div class="input-group input-group-sm" style="width: 150px">
            <input
              @keyup="buscarEmailsByLista"
              type="text"
              name="table_search"
              v-model="nome"
              class="form-control float-right"
              placeholder="Search"
            />

            <div class="input-group-append">
              <button type="submit" class="btn btn-secondary" id="searchBtn" @click="buscarEmailsByLista(true)">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="card-body table-responsive p-0">
      <table class="table table-hover text-nowrap">
        <thead>
          <tr>
            <th>Seq</th>
            <th>Id</th>
            <th>Email</th>
            <th>Apelido</th>
            <th>Tipo</th>
            <th>Criado em</th>
            <th>Verificado em</th>
            <th>Interações</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(lista, index) in newsletter_emails_lista" :key="lista">
            <td>{{ index + 1 }}</td>
            <td>{{ lista.id }}</td>
            <td>{{ lista.email }}</td>
            <td>{{ lista.apelido }}</td>

            <td>
              <span class="right badge badge-danger" style="margin-left: 15px; background-color: #301904" v-if="lista.cadastro_tipo == 'pj'">PJ</span>
              <span class="right badge badge-danger" style="margin-left: 15px; background-color: blue" v-if="lista.cadastro_tipo == 'pf'">PF</span>
            </td>

            <td>{{ formatDate(lista.created_at) }}</td>
            <td>
              <span v-if="lista.verified_at">{{ formatDate(lista.verified_at) }}</span>
            </td>
            <td>{{ lista.interacoes }}</td>

            <td data-label="Ações">
              <button @click="excluir(lista)" type="submit" class="btn btn-primary">Excluir</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer clearfix">
      <div style="font-size: 13px" class="float-left" aria-live="polite">
        Exibindo do {{ inicio + 1 }} ao {{ inicio + newsletter_emails_lista.length }}
        <p>Total {{ total }}</p>
      </div>

      <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

      <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
        <option :value="10">10</option>
        <option :value="25">25</option>
        <option :value="50">50</option>
        <option :value="100">100</option>
        <option :value="200">200</option>
      </select>

      <div class="card-tools">
        <div class="input-group input-group-sm" style="width: 150px"></div>
      </div>

      <!-- PAGINAÇÃO  -->
      <ul class="pagination pagination-sm m-0 float-right">
        <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
        <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

        <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
          <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
            {{ pagina }}
          </a>
        </li>

        <li class="page-item">
          <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
        </li>
        <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["lista_selecionada"],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      registro_selecionado: "",
      filtro: "",
      paginas: [],
      registros: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 10,
      pagina_atual: 1,
      nome: "",
      max_page: 0,
      editar_registro: false,
      cadastrar_registro: false,
      newsletter_listas: [],
      newsletter_emails_lista: "",
      total_newsletter_emails_lista: "",
      newsletter_emails_not_in_lista: "",
      total_newsletter_emails_not_in_lista: "",
    };
  },

  mounted() {
    console.log("LISTANDO EMAILS BY LISTA");
    console.log(this.lista_selecionada);

    this.buscarEmailsByLista();
  },

  methods: {
    excluir(email_selecionado) {
      let html = "Deseja apagar o e-mail <b>" + email_selecionado.email + "</b>? Essa ação é irreversível.";

      this.$swal
        .fire({
          title: "Confirmação",
          html: html,
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              email_id: email_selecionado.id,
              lista_id: this.lista_selecionada.id,
            };

            axios
              .post(`/admin/newsletter_emails/remove_from_lista`, data)
              .then((response) => {
                this.showSuccessMessage("E-mail removido com sucesso!");
                this.buscarEmailsByLista();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    buscarEmailsByLista() {
      this.isLoading = true;

      let data = {
        nome: this.nome,
        lista_id: this.lista_selecionada.id,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log("BUSCANDO BY LISTA");
      console.log(data);

      axios
        .post("/admin/newsletter_emails/search_by_lista", data)
        .then((response) => {
          this.newsletter_emails_lista = response.data.newsletter_emails;
          this.total = response.data.total;

          console.log("RESPOSTA");
          console.log(response.data);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarEmailsByLista();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarEmailsByLista();
      }
    },

    limparFiltros() {
      this.objeto = null;
      this.registros = [];
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);
      console.log("Max = " + this.max_page);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarRegistros();
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>
